import { SxProps, TextField as MuiTextField, Theme } from '@mui/material'
import React, { FocusEventHandler, forwardRef, useMemo } from 'react'
import { Control, Controller } from 'react-hook-form'
import { IMaskInput } from 'react-imask'

type InputMaskProps = {
  label: string
  name: string
  mask: string
  definitions?: any
  placeholder?: string
  sx?: SxProps<Theme>
  control: Control<any>
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  onFocus?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  disabled?: boolean
  autoComplete?: string
  required?: boolean
  readonly?: boolean
}

type CustomProps = {
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
}

const InputMask: React.FC<InputMaskProps> = ({
  label,
  name,
  mask,
  definitions,
  placeholder,
  sx,
  control,
  onBlur,
  onFocus,
  disabled,
  autoComplete,
  required = false,
  readonly,
}) => {
  const TextMaskCustom = useMemo(
    () =>
      forwardRef<HTMLInputElement, CustomProps>(function TextMaskCustom(props, ref) {
        const { onChange, ...other } = props
        return (
          <IMaskInput
            {...other}
            mask={mask}
            placeholder={placeholder}
            definitions={definitions}
            inputRef={ref}
            onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
            autoComplete={autoComplete}
            readOnly={readonly}
          />
        )
      }),
    [mask, placeholder, definitions, autoComplete],
  )

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <MuiTextField
          fullWidth
          id={`${name}Id`}
          label={label}
          name={name}
          size='small'
          value={value && String(value)}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          InputProps={{
            inputComponent: TextMaskCustom as any,
          }}
          sx={sx}
          error={!!error}
          helperText={error && error.message && error.message}
          disabled={disabled}
          required={required}
        />
      )}
    />
  )
}

export default InputMask
